module.exports = "/assets/data/d1c657ecba236fd7fc49265bae07af39-GL54.data.json";